import React, { useState } from 'react'
import classNames from 'classnames'
import ActionMenu from 'components/ActionMenu'
import VerticalButtonMenu from 'components/VerticalButtonMenu'
import { ChevronRightIcon } from 'images/common'
import './ActionBoxRowButton.scss'

const ActionBoxRowButton = ({ action, color, row, itemHover, isDisabled, isLastRow, isHoverAction, isExpanded, isSelected, onClickMenu }) => {
  const [actionHover, toggleActionHover] = useState(false)
  const iconColor = isExpanded ? action.expandedIconColor : action.iconColor

  return (
    <div className={classNames(
      'viso-action-box-row-button',
      isLastRow && 'viso-action-box-row-button--last',
      itemHover && 'viso-action-box-row-button--hover',
      isHoverAction && 'viso-action-box-row-button--hover-action',
      isExpanded && 'viso-action-box-row-button--expanded',
      isSelected && 'viso-action-box-row-button--selected'
    )}>
      {action.type === 'menu' ? (
        action.menuItems?.length > 0 &&
        <VerticalButtonMenu
          color={color}
          modifier='action-box-row'
          onClickMenu={() => {
            if(onClickMenu) {
              onClickMenu(true)
            }
          }}
          onCloseMenu={() => {
            if(onClickMenu) {
              onClickMenu(false)
            }
          }}
        >
          {action.menuItems.map((item, index) =>
            item.isDivider ?
              <React.Fragment key={index}><hr /></React.Fragment>
              :
              !(typeof item.hideItem === 'function' ? item.hideItem(row) : !!item.hideItem) &&
              <ActionMenu
                key={index}
                onClick={(e) => {
                  e.stopPropagation()
                  item.onClick(row)
                }}
                icon={item.icon}
                text={item.label}
                disabled={typeof item.disabledCheck === 'function' ? item.disabledCheck(row) : item.disabled}
                className={item.className}
                type={item.type}
                to={item.to}
              />
          )}
        </VerticalButtonMenu>
      ) : (
        <button
          type='button'
          className={classNames(
            'viso-action-box-row-button__handler',
            isHoverAction && 'viso-action-box-row-button__handler--hover-action'
          )}
          onClick={() => action.onClick(row)}
          onMouseEnter={() => toggleActionHover(true)}
          onMouseLeave={() => toggleActionHover(false)}
        >
          <span className={classNames(
            'viso-action-box-row-button__icon',
            isDisabled && 'viso-text-border',
            !isDisabled && !actionHover && iconColor && `viso-text-${iconColor}`,
            actionHover && `viso-text-${color}`
          )}>
            {isExpanded ? action.expandedIcon : action.icon ? action.icon : <ChevronRightIcon />}
          </span>
        </button>
      )}
    </div>
  )
}

export default ActionBoxRowButton